import theme from "../Styles/mainTheme";
import useStyles from "../Styles/useStyles";
import { api } from "../variables";
import { getRequestUrl } from "../helpFunctions";
import NavBar from "../Components/NavBar";
import "../App.css";
import React, { Fragment, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Container, Typography } from "@material-ui/core";
import Axios from "axios";
import queryString from "query-string";

const Boleto = () => {
  const location = useLocation();
  const classes = useStyles();
  const [pdf, setPdf] = useState(null);
  const [carregado, setCarregado] = useState(false);
  const [semBoletos, setSemBoletos] = useState(false);

  const toBlob = (base64, type = "application/pdf") => {
    const binStr = atob(base64);
    const len = binStr.length;
    const arr = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      arr[i] = binStr.charCodeAt(i);
    }
    return new Blob([arr], { type: type });
  };

  const request = (url, boletos) => {
    if (!boletos) {
      Axios.get(url)
        .then((res) => {
          setPdf(res.data);
        })
        .catch(() => {
          setSemBoletos(true);
        });
    } else {
      Axios.post(url, {
        objeto: location.state.objeto,
      })
        .then((res) => {
          const query = queryString.parse(location.search);
          sessionStorage.setItem("pathname", "/lista_boletos");

          let pdfWindow = window.open("", "_blank");
          pdfWindow.document.title = document.title;
          pdfWindow.document.write(
            "<iframe width='100%' height='100%' src='" + URL.createObjectURL(toBlob(res.data)) + "'></iframe>"
          );
          pdfWindow.history.pushState("", "", "/boleto?data=" + query.data);
          pdfWindow.document.title = document.title;

          window.history.back();
        })
        .catch(() => {
          setSemBoletos(true);
        });
    }
  };

  useEffect(() => {
    const query = queryString.parse(location.search);
    var url = getRequestUrl(query.data, query.cnpj, query.nota);
    if (sessionStorage.getItem("pathname") === "/boleto") request(url, location.state.objeto);
    else request(url);
  }, []);

  const render = () => {
    return (
      <Fragment>
        <NavBar />
        <main className={classes.main}>
          <Container maxWidth="md">
            <Typography
              component="h6"
              variant="h6"
              aling="justify"
              color="textPrimary"
              style={{ paddingTop: "4.5%", textAlign: "justify" }}
            >
              Não foram encontrados boletos para este documento, favor entrar em contato com o nosso financeiro para
              maiores informações.
            </Typography>
          </Container>
        </main>
      </Fragment>
    );
  };

  const renderBoletos = () => {
    return (
      <Fragment>
        {console.log(toBlob(pdf))}
        <iframe src={URL.createObjectURL(toBlob(pdf))} style={{ width: "100%", height: "100vh" }}></iframe>
      </Fragment>
    );
  };

  return <Fragment>{semBoletos === true ? render() : pdf === null ? null : renderBoletos()}</Fragment>;
};

export default Boleto;
